// Permission configuration for menu items
// Only pages that need restrictions should be listed here
export const restrictedPages = {
  reports: [
      'arikgoldshtein',
      'Mrkristal'
  ], // Only specific users can see reports
  revertVersion: [
      'arikgoldshtein',
      'Mrkristal',
      'afiku',
      'esapir',
      'offirt',
      'zivbens',
      'adi-tonkean'
  ], // Only specific users can revert versions
};

// Helper function to check if a page is restricted
export const isPageRestricted = (page: keyof typeof restrictedPages): boolean => {
  return page in restrictedPages;
};

// Helper function to get allowed users for a restricted page
export const getAllowedUsers = (page: keyof typeof restrictedPages): string[] => {
  return restrictedPages[page] || [];
};
